import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { submitFormData } from '../../../pages/api';

const Form_12 = () => {
    const navigate = useNavigate();

    const fields = [
        {
            section: 'frameWeightWithoutGlue',
            label: 'Frame Weight without Glue',
            fields: [
                { label: 'Frame Weight Long 1', name: 'frameWeightLong1', type: 'number' },
                { label: 'Frame Weight Long 2', name: 'frameWeightLong2', type: 'number' },
                { label: 'Frame Weight Short 1', name: 'frameWeightShort1', type: 'number' },
                { label: 'Frame Weight Short 2', name: 'frameWeightShort2', type: 'number' },
            ],
        },
        {
            section: 'frameWeightWithGlue',
            label: 'Frame Weight with Glue',
            fields: [
                { label: 'Frame Weight Long 1', name: 'frameWeightLong1', type: 'number' },
                { label: 'Frame Weight Long 2', name: 'frameWeightLong2', type: 'number' },
                { label: 'Frame Weight Short 1', name: 'frameWeightShort1', type: 'number' },
                { label: 'Frame Weight Short 2', name: 'frameWeightShort2', type: 'number' },
            ],
        },
        {
            section: 'weightOfGlue1Set',
            label: 'Weight of Glue 1 Set',
            fields: [
                { label: 'Glue Weight L1', name: 'glueWeightL1', type: 'number', readOnly: true },
                { label: 'Glue Weight L2', name: 'glueWeightL2', type: 'number', readOnly: true },
                { label: 'Glue Weight S1', name: 'glueWeightS1', type: 'number', readOnly: true },
                { label: 'Glue Weight S2', name: 'glueWeightS2', type: 'number', readOnly: true },
            ],
        },
        { label: 'Total Module Glue Weight', name: 'totalModuleGlueWeight', type: 'number', readOnly: true },
        { label: 'Remarks', name: 'remarks', type: 'text' },
    ];

    const [lines, setLines] = useState([]);
    const [date, setDate] = useState(() => sessionStorage.getItem('inspectionDate') || '');
    const [shift, setShift] = useState(() => sessionStorage.getItem('inspectionShift') || '');
    const [formData, setFormData] = useState({});
    const [selectedLine, setSelectedLine] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const generateDefaultLineData = (linesArray) => {
        return linesArray.reduce((acc, line) => {
            acc[line] = fields.reduce((fieldAcc, field) => {
                if (field.section) {
                    fieldAcc[field.section] = field.fields.reduce((sectionAcc, subField) => {
                        sectionAcc[subField.name] = '';
                        return sectionAcc;
                    }, {});
                } else {
                    fieldAcc[field.name] = '';
                }
                return fieldAcc;
            }, {});
            return acc;
        }, {});
    };

    // Fetch lines from metadata and initialize form data
    useEffect(() => {
        const metadata = sessionStorage.getItem('metadata');
        if (metadata) {
            try {
                const parsedMetadata = JSON.parse(metadata);
                const fetchedLines = parsedMetadata.lines.map(item => item.Lines);
                setLines(fetchedLines);
                setSelectedLine(fetchedLines[0] || '');

                const savedData = sessionStorage.getItem('FrameSealantWeightF12formData');
                let initialData = savedData ? JSON.parse(savedData) : generateDefaultLineData(fetchedLines);

                // Ensure all fetched lines are present in formData
                fetchedLines.forEach(line => {
                    if (!initialData[line]) {
                        initialData[line] = fields.reduce((fieldAcc, field) => {
                            if (field.section) {
                                fieldAcc[field.section] = field.fields.reduce((sectionAcc, subField) => {
                                    sectionAcc[subField.name] = '';
                                    return sectionAcc;
                                }, {});
                            } else {
                                fieldAcc[field.name] = '';
                            }
                            return fieldAcc;
                        }, {});
                    }
                });

                setFormData(initialData);
            } catch (error) {
                console.error('Error parsing metadata or saved data:', error);
            }
        }
    }, []);

    const isObjectEmpty = (obj) => {
        return Object.values(obj).every((value) => {
            if (typeof value === 'object' && value !== null) {
                return isObjectEmpty(value);
            }
            return value === '' || value === null || value === undefined;
        });
    };

    // Auto-calculation function
    const calculateGlueWeights = (data, line) => {
        const withoutGlue = data[line].frameWeightWithoutGlue;
        const withGlue = data[line].frameWeightWithGlue;
        
        const glueWeights = {
            glueWeightL1: (parseFloat(withGlue.frameWeightLong1) || 0) - (parseFloat(withoutGlue.frameWeightLong1) || 0),
            glueWeightL2: (parseFloat(withGlue.frameWeightLong2) || 0) - (parseFloat(withoutGlue.frameWeightLong2) || 0),
            glueWeightS1: (parseFloat(withGlue.frameWeightShort1) || 0) - (parseFloat(withoutGlue.frameWeightShort1) || 0),
            glueWeightS2: (parseFloat(withGlue.frameWeightShort2) || 0) - (parseFloat(withoutGlue.frameWeightShort2) || 0),
        };

        const totalModuleGlueWeight = (
            glueWeights.glueWeightL1 +
            glueWeights.glueWeightL2 +
            glueWeights.glueWeightS1 +
            glueWeights.glueWeightS2
        ) || 0;

        return {
            ...data,
            [line]: {
                ...data[line],
                weightOfGlue1Set: glueWeights,
                totalModuleGlueWeight: totalModuleGlueWeight.toString()
            }
        };
    };

    useEffect(() => {
        const inspectionDate = sessionStorage.getItem('inspectionDate');
        const inspectionShift = sessionStorage.getItem('inspectionShift');
        if (inspectionDate && inspectionShift) {
            setDate(inspectionDate);
            setShift(inspectionShift);
        }
    }, []);

    useEffect(() => {
        if (lines.length > 0) {
            const inspectionData = sessionStorage.getItem('inspectionData');
            if (!inspectionData) return;

            try {
                const parsedInspectionData = JSON.parse(inspectionData);
                const verificationData = parsedInspectionData.FrameSealantWeightVerification || {};

                setFormData((prevData) => {
                    let updatedData = { ...prevData };
                    lines.forEach((line) => {
                        if (isObjectEmpty(updatedData[line])) {
                            updatedData[line] = {
                                ...updatedData[line],
                                frameWeightWithoutGlue: verificationData[line]?.frameWeightWithoutGlue || updatedData[line].frameWeightWithoutGlue,
                                frameWeightWithGlue: verificationData[line]?.frameWeightWithGlue || updatedData[line].frameWeightWithGlue,
                                weightOfGlue1Set: verificationData[line]?.weightOfGlue1Set || updatedData[line].weightOfGlue1Set,
                                totalModuleGlueWeight: verificationData[line]?.totalModuleGlueWeight || updatedData[line].totalModuleGlueWeight,
                                remarks: verificationData[line]?.remarks || updatedData[line].remarks,
                            };
                        }
                    });
                    // Calculate glue weights after initial data load for the selected line
                    updatedData = calculateGlueWeights(updatedData, selectedLine);
                    return updatedData;
                });
            } catch (error) {
                console.error('Error parsing inspectionData:', error);
            }
        }
    }, [lines, selectedLine]);

    useEffect(() => {
        if (Object.keys(formData).length > 0) {
            sessionStorage.setItem('FrameSealantWeightF12formData', JSON.stringify(formData));
        }
    }, [formData]);

    const handleChange = (e, section = null, field = null) => {
        const { name, value } = e.target;

        setFormData((prevData) => {
            let updatedData = {
                ...prevData,
                [selectedLine]: section
                    ? {
                          ...prevData[selectedLine],
                          [section]: {
                              ...prevData[selectedLine][section],
                              [field]: value,
                          },
                      }
                    : {
                          ...prevData[selectedLine],
                          [name]: value,
                      },
            };
            // Recalculate glue weights after every change
            updatedData = calculateGlueWeights(updatedData, selectedLine);
            return updatedData;
        });
    };

    const handleLineChange = (e) => {
        setSelectedLine(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const payload = {
                projectId: localStorage.getItem('selectedProject'),
                inspectionSupplier: sessionStorage.getItem('inspectionSupplier'),
                inspectionDate: date,
                inspectionShift: shift,
                inspectorName: sessionStorage.getItem('username'),
                status: 'completed',
                FrameSealantWeightVerification: formData,
            };

            await submitFormData(payload);
            alert('Form submitted successfully!');
        } catch (error) {
            console.error('Error submitting form:', error);
            alert(`Failed to submit form: ${error.message || 'Unknown error'}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-lg space-y-4">
            <h2 className="text-2xl font-bold text-center mb-4">Frame Sealant Weight Verification</h2>
            <p className="text-center font-semibold mb-4">Frequency: Once Per Shift</p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div>
                    <label className="block font-semibold mb-1">Date</label>
                    <input
                        type="date"
                        value={date}
                        readOnly
                        className="w-full p-2 border rounded bg-gray-100"
                    />
                </div>
                <div>
                    <label className="block font-semibold mb-1">Shift</label>
                    <input
                        type="text"
                        value={shift}
                        readOnly
                        className="w-full p-2 border rounded bg-gray-100"
                    />
                </div>
                <div>
                    <label className="block font-semibold mb-1">Line</label>
                    <select
                        value={selectedLine}
                        onChange={handleLineChange}
                        className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500"
                        disabled={lines.length === 0}
                    >
                        {lines.length === 0 ? (
                            <option value="">No lines available</option>
                        ) : (
                            lines.map((line) => (
                                <option key={line} value={line}>
                                    {line}
                                </option>
                            ))
                        )}
                    </select>
                </div>
            </div>

            {lines.length > 0 && fields
                .filter((field) => field.section)
                .map(({ section, label, fields: sectionFields }) => (
                    <div key={section}>
                        <h3 className="text-xl font-semibold mt-4">{label}</h3>
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-2">
                            {sectionFields.map(({ label: subLabel, name, type, readOnly }) => (
                                <div key={name}>
                                    <label className="block font-semibold mb-1">{subLabel}</label>
                                    <input
                                        type={type || 'text'}
                                        name={name}
                                        value={formData[selectedLine]?.[section]?.[name] || ''} 
                                        onChange={(e) => !readOnly && handleChange(e, section, name)}
                                        className={`w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 ${readOnly ? 'bg-gray-100' : ''}`}
                                        readOnly={readOnly}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

            {lines.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                    {fields
                        .filter((field) => !field.section)
                        .map(({ label, name, type, readOnly }) => (
                            <div key={name}>
                                <label className="block font-semibold mb-1">{label}</label>
                                <input
                                    type={type || 'text'}
                                    name={name}
                                    value={formData[selectedLine]?.[name] || ''} 
                                    onChange={(e) => !readOnly && handleChange(e)}
                                    className={`w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 ${readOnly ? 'bg-gray-100' : ''}`}
                                    readOnly={readOnly}
                                />
                            </div>
                        ))}
                </div>
            )}

            <div className="flex justify-between mt-6">
                <button
                    type="button"
                    onClick={() => navigate('/inspections/section2/form11')}
                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                    Previous
                </button>
                <button
                    type="submit"
                    disabled={isLoading}
                    className="px-4 py-2 bg-[#424752] text-white rounded hover:bg-gray-500 disabled:bg-gray-400"
                >
                    {isLoading ? 'Submitting...' : 'Submit'}
                </button>
                <button
                    type="button"
                    onClick={() => navigate('/inspections/section2/form13')}
                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                    Next
                </button>
            </div>
        </form>
    );
};

export default Form_12;